<template>
  <div class="chat-configure-form mt-4">
    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 2fr) minmax(0, 1fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <!-- Left column: Configuration options -->
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:100%">
            <div class="Polaris-LegacyCard">
              <!-- WhatsApp Configuration Section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      WhatsApp Chat Configuration
                    </h2>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                      Configure whatsapp by adding your number
                    </p>
                  </div>
                </div>
              </div>

              <!-- Phone Number Section -->
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <Alert v-if="showAlert" :text="alertText" />
                <form @submit="handleSubmit">
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Phone Number</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <vue-tel-input
                              :value="phoneNumber"
                              :disabledFetchingCountry="true"
                              mode="international"
                              @input="handlePhoneNumberUpdate"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Position Section -->
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Position
                    </h2>
                  </div>
                </div>

                <div class="mt-4 flex flex-wrap">
                  <div
                    class="flex items-center m-2"
                    v-for="(position, index) in supportedPosition"
                    :key="index"
                  >
                    <input
                      :id="`radio_${position.value}`"
                      type="radio"
                      class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      v-model="config.position"
                      :value="position.value"
                    />
                    <label :for="`radio_${position.value}`" class="ml-3">
                      <span
                        class="block text-sm leading-5 font-medium text-gray-700"
                        >{{ position.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Design Section -->
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Design
                    </h2>
                  </div>
                </div>

                <div class="mt-4 flex flex-wrap">
                  <div
                    class="flex items-center m-2"
                    v-for="(design, index) in supportedDesign"
                    :key="index"
                  >
                    <input
                      :id="`radio_design_${design.value}`"
                      type="radio"
                      class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      v-model="config.design"
                      :value="design.value"
                    />
                    <label :for="`radio_design_${design.value}`" class="ml-3">
                      <span
                        class="block text-sm leading-5 font-medium text-gray-700"
                        >{{ design.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Colors Section -->
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Colors
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(1, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <!-- Button Background Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Background</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="config.colors.buttonBackgroundColor"
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="config.colors.buttonBackgroundColor"
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Button Text Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Text Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="config.colors.buttonTextColor"
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="config.colors.buttonTextColor"
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Button Icon Color -->
                      <div class="Polaris-FormLayout__Item relative">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button Icon Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="config.colors.buttonIconColor"
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="config.colors.buttonIconColor"
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Text & Settings Section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Text & Settings
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <!-- Button Label -->
                    <div class="Polaris-FormLayout__Item">
                      <div class="Polaris-Labelled__LabelWrapper">
                        <div class="Polaris-Label">
                          <label class="Polaris-Label__Text"
                            >Button Label</label
                          >
                        </div>
                      </div>
                      <div class="Polaris-Connected">
                        <div
                          class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                        >
                          <div class="Polaris-TextField">
                            <input
                              class="Polaris-TextField__Input"
                              v-model="config.texts.contactUsLabel"
                              type="text"
                            />
                            <div class="Polaris-TextField__Backdrop"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Include Product URL checkbox -->
                    <div class="Polaris-FormLayout__Item mt-4">
                      <label
                        class="Polaris-Choice Polaris-Checkbox__ChoiceLabel"
                        for="includeProducturl"
                      >
                        <span class="Polaris-Choice__Control">
                          <span class="Polaris-Checkbox">
                            <input
                              id="includeProducturl"
                              type="checkbox"
                              class="Polaris-Checkbox__Input"
                              v-model="config.addProductUrlInMessage"
                              aria-invalid="false"
                              role="checkbox"
                              aria-checked="false"
                            />
                            <span class="Polaris-Checkbox__Backdrop"></span>
                            <span
                              class="Polaris-Checkbox__Icon Polaris-Checkbox--animated"
                            >
                              <svg
                                viewBox="0 0 16 16"
                                shape-rendering="geometricPrecision"
                                text-rendering="geometricPrecision"
                              >
                                <path
                                  class=""
                                  d="M1.5,5.5L3.44655,8.22517C3.72862,8.62007,4.30578,8.64717,4.62362,8.28044L10.5,1.5"
                                  transform="translate(2 2.980376)"
                                  opacity="0"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  pathLength="1"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span class="Polaris-Choice__Label">
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">
                            Include product URL while customer initiates the
                            chat
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right column: Preview -->
      <div>
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                  WhatsApp Button Preview
                </h2>
                <div
                  class="mt-6 p-4 border rounded bg-gray-50 flex justify-center"
                >
                  <WhatsappButton :config="config" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "./Alert";
import { VueTelInput } from "vue-tel-input";

import Verte from "verte";
import "verte/dist/verte.css";

import WhatsappButton from "./WhatsappButton";

export default {
  name: "ChatConfigureForm",
  components: {
    Alert,
    VueTelInput,
    Verte,
    WhatsappButton
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {
    "config.phoneNumber"(newValue) {
      if (newValue !== this.phoneNumber) {
        this.phoneNumber = newValue;
      }
    }
  },
  data() {
    return {
      phoneNumber: "",
      defaultTemplate: "",
      alertText: "",
      showAlert: false,

      supportedPosition: [
        {
          label: "Left",
          value: "left"
        },
        {
          label: "Right",
          value: "right"
        }
      ],
      supportedDesign: [
        {
          label: "Button With Text and Icon",
          value: "buttonWithTextIcon"
        },
        {
          label: "Button With Icon",
          value: "buttonWithIcon"
        }
      ],
      showAdvanced: false
    };
  },
  computed: {
    hasMoreCharacters() {
      const label = this.config.texts.contactUsLabel;
      return label.length > 20;
    }
  },
  mounted() {
    this.phoneNumber = this.config.phoneNumber;
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, event) {
      console.log(event);
      if (this.config.phoneNumber != event.number && event.number) {
        this.config.phoneNumber = event.number;
      }
      // if (isValid) {

      // }
    },
    init() {
      this.$store.dispatch("getChatConfig");
    },
    save() {
      if (this.hasMoreCharacters) {
        this.alertText = "Button Label should be less than 12 characters";
        this.showAlert = true;

        return;
      }
      this.alertText = "";
      this.showAlert = false;
      this.$emit("save");
    },
    openPreviewUrl() {
      const store = this.$store.getters.getStore;
      const shopOrigin = store.shopOrigin;
      window.open(`https://${shopOrigin}/?carthike_version=${Date.now()}`);
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 30px;
  left: 8px;
  z-index: 100;
}

/* Target the color picker when it's active/open */
.verte.colorPicker .verte__menu-origin--active {
  z-index: 10000 !important;
}

/* Also ensure the parent element has higher z-index when active */
.verte.colorPicker:has(.verte__menu-origin--active) {
  z-index: 10000 !important;
}

/* For browsers that don't support :has selector */
.Polaris-Connected__Item--primary:focus-within .verte.colorPicker,
.Polaris-Connected__Item--primary:hover .verte.colorPicker {
  z-index: 10000 !important;
}

.Polaris-TextField__Input.hasColor {
  padding-left: 42px;
}

.chat-configure-form .Polaris-LegacyCard {
  overflow: visible;
}

.chat-configure-form .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.chat-configure-form .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
